import { useEffect } from 'react';

/**
 * Custom hook to prevent mobile pinch-to-zoom gestures on the current page.
 * Useful for map pages where zooming the page interferes with map interactions.
 */
export const usePreventMobileZoom = (enabled: boolean = true): void => {
    useEffect(() => {
        if (!enabled) return;

        const preventZoom = (e: Event) => e.preventDefault();
        
        document.addEventListener('gesturestart', preventZoom);
        document.addEventListener('gesturechange', preventZoom);
        document.addEventListener('gestureend', preventZoom);
        
        return () => {
            document.removeEventListener('gesturestart', preventZoom);
            document.removeEventListener('gesturechange', preventZoom);
            document.removeEventListener('gestureend', preventZoom);
        };
    }, [enabled]);
};
